import React, { useEffect } from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import {
  getOpenHoursTextUniteUs,
  getAddressTextUniteUs,
} from '@src/utills/utils';
import {
  capitalizeSentenceFirstLetters,
  toPascalCase,
} from '../../../../../packages/utils/src/helpers/capitalize';
import { Brandmark } from '@uhg-abyss/web/ui/Brandmark';
import { Box } from '@uhg-abyss/web/ui/Box';
import { CboCardUniteUsNextSteps } from '../../../../../packages/ui/src/CboCardUniteUs/CboCardUniteUsNextSteps';
// import { capitalizeSentenceFirstLetters } from '@repo/utils/src/helpers/capitalize';

export type DetailsPageProps = {
  programData: any;

  printTab: boolean;
};

export const DetailsPageUnitUs = ({
  programData,
  printTab,
}: DetailsPageProps) => {
  useEffect(() => {
    if (printTab) {
      window.print();
    }
  }, [printTab]);

  const addressText = getAddressTextUniteUs(
    programData?.document?.locations[0]
  );
  const services = programData.relationships.services.data;

  const service = services?.length
    ? services
        .map((service) => {
          // Ensure service.label is defined
          const label = service.label || '';
          return capitalizeSentenceFirstLetters(label);
        })
        .join(', ')
    : 'No services available';

  const closestLocation =
    programData?.document?.locations.find((location) => {
      return location.is_closest;
    }) || programData?.document?.locations[0];
  const email = closestLocation?.email_addresses?.[0] ?? '';
  const websiteUrl = programData?.document?.website_url;

  const langCodeShort = 'en'; // to show in English
  const displayNames = new Intl.DisplayNames([langCodeShort], {
    type: 'language',
  });

  const NextStepsElement = () => {
    return (
      <CboCardUniteUsNextSteps
        closestOfficeAddressText={addressText}
        closestOfficeEmail={email}
        closestOfficePhone={closestLocation?.phone_numbers ?? ['']}
        closestOfficeWebsite={websiteUrl ?? ''}
      />
    );
  };

  function capitlalizeWordFirstLetter(word: string): string {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1);
  }
  return (
    <React.Fragment>
      <div
        className="printOnly"
        style={{ top: 0, position: 'absolute', width: '100%' }}
      >
        <Box color="$white">
          <Brandmark
            brand="uhc"
            size="$sm"
            affiliate="uhc"
            variant="lockup"
            color="blue"
          />
        </Box>
        <hr />
      </div>

      <div
        className="noPrint"
        style={{
          // backgroundColor: '#eef8fb',
          display: 'flex',
          padding: '2%',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <Heading>
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                color: 'black',
              }}
            >
              {programData?.document.name}
            </span>
          </Heading>
          {programData?.relationships?.provider?.data?.document?.name && (
            <Text color="$core.color.neutral.100">
              by&nbsp;
              <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md" style={{ display: 'inline' }}>
                {programData.relationships.provider.data.document.name}
              </Text>
            </Text>
          )}
          <br />
          <br />
          <br />
          <span
            style={{
              display: 'inline-block',
            }}
            dangerouslySetInnerHTML={{
              __html: programData?.document?.description,
            }}
          />
        </div>
      </div>

      <Heading
        color="$core.color.neutral.100"
        className="noPrint"
        style={{
          paddingRight: '2%',
          paddingLeft: '2%',
          paddingTop: '2%',
        }}
      >
        Information
      </Heading>
      <Heading className="printOnly" color="$core.color.neutral.100">
        {programData?.document.name}
      </Heading>
      <br className="printOnly" />
      {programData?.relationships?.provider?.data?.document?.name && (
        <p className="printOnly">
          <span>by </span>
          <Text color="$core.color.neutral.100">
            {programData.relationships.provider.data.document.name}
          </Text>
        </p>
      )}
      <br className="printOnly" />

      <Text className="printOnly">
        <div
          dangerouslySetInnerHTML={{
            __html: programData?.document?.description,
          }}
        />
      </Text>
      <br className="printOnly" />
      <div className="information">
        <div>
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Main Services
          </Text>
          <br />
          {services.length > 0 ? (
            <span className="leftcolspacing">{service}</span>
          ) : (
            <span className="leftcolspacing">
              No main services information available
            </span>
          )}

          <br />
          <br className="noPrint" />
          <br className="printOnly" />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Serving
          </Text>
          <br />
          <Text>
            {programData.document.population_specializations.length > 0 ? (
              <span className="leftcolspacing">
                {programData.document.population_specializations
                  ?.map((tag) =>
                    capitlalizeWordFirstLetter(tag.replace(/_/g, ' '))
                  )
                  .join(', ')}
              </span>
            ) : (
              <span className="leftcolspacing">
                No serving information available
              </span>
            )}
          </Text>

          <br />
          <br className="noPrint" />
          <br className="printOnly" />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Eligibility
          </Text>
          <br />
          {programData.document?.eligibility_text ? (
            <Text>
              <div
                dangerouslySetInnerHTML={{
                  __html: programData.document?.eligibility_text,
                }}
              />
            </Text>
          ) : (
            <span className="leftcolspacing">
              No eligibility information is available
            </span>
          )}
          <br />
          <br className="noPrint" />
          <br className="printOnly" />
          <Text color="black" fontWeight="bold" size="$md" width="100%">
            Cost
          </Text>
          <br />
          {programData.document.payment_options &&
          programData.document.payment_options.length > 0 ? (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              {programData.document.payment_options
                .map((payment_option) => {
                  return capitlalizeWordFirstLetter(
                    payment_option.replace(/_/g, ' ')
                  );
                })
                .join(', ')}
            </Text>
          ) : (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              No pricing information is available
            </Text>
          )}
          <br />
          <br className="noPrint" />
          <br className="printOnly" />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md" width="100%">
            Languages
          </Text>
          <br />
          {programData.document.languages &&
          programData.document.languages.length > 0 ? (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              {programData.document.languages
                .map((language) => {
                  // Use Intl.DisplayNames to get the full language name
                  try {
                    return (
                      displayNames.of(language) ||
                      capitlalizeWordFirstLetter(language)
                    );
                  } catch {
                    return capitlalizeWordFirstLetter(language);
                  }
                })
                .join(', ')}
            </Text>
          ) : (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              No language information is available
            </Text>
          )}

          <br />
          <br className="noPrint" />
          <br className="printOnly" />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Availability
          </Text>
          <br />
          <span className="leftcolspacing">
            {programData.receiving_referrals && programData?.active
              ? 'Availability information is available'
              : 'No availability information is available'}
          </span>
          <br />
          <br className="noPrint" />
          <br className="printOnly" />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Coverage Area
          </Text>
          <br />
          <span className="leftcolspacing">
            {programData?.document?.locations[0]?.county
              ? toPascalCase(programData.document.locations[0].county)
              : 'No coverage area information is available'}
          </span>
          <br />
          <br className="noPrint" />
          <br className="printOnly" />
        </div>
        <div>
          <NextStepsElement />

          <br className="noPrint" />
          <br className="printOnly" />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md" width="100%">
            Location
          </Text>
          <br />
          <Text color="$core.color.neutral.100">{addressText}</Text>
          <br />
          {programData?.document?.distance && programData?.document?.locations?.[0]?.postal_code && (
            <div><Text color="$core.color.neutral.100">
              {programData.document.distance.toString().replace('mi', '').trim()} miles from {programData.document.locations[0].postal_code}
            </Text>
            <br className="noPrint" />
            <br className="printOnly" />
            </div>
          )}

          <br />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Population Restrictions: &nbsp;
          </Text>

          {programData?.document?.population_restrictions &&
          programData?.document?.population_restrictions.length > 0 ? (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              {programData.document.population_restrictions
                .map((restriction) => {
                  return capitlalizeWordFirstLetter(
                    restriction.replace(/_/g, ' ')
                  );
                })
                .join(', ')}
            </Text>
          ) : (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              No population restrictions
            </Text>
          )}
          <br className="noPrint" />
          <br className="printOnly" />
          <br />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Restricted Cities: &nbsp;
          </Text>

          {programData?.document?.restricted_cities &&
          programData?.document?.restricted_cities.length > 0 ? (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              {programData.document.restricted_cities
                .map((city) => {
                  return capitlalizeWordFirstLetter(city.replace(/_/g, ' '));
                })
                .join(', ')}
            </Text>
          ) : (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              No restricted cities
            </Text>
          )}
          <br className="noPrint" />
          <br className="printOnly" />
          <br />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Restricted Counties: &nbsp;
          </Text>

          {programData?.document?.restricted_counties &&
          programData?.document?.restricted_counties.length > 0 ? (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              {programData.document.restricted_counties
                .map((county) => {
                  return capitlalizeWordFirstLetter(county.replace(/_/g, ' '));
                })
                .join(', ')}
            </Text>
          ) : (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              No restricted counties
            </Text>
          )}
          <br className="noPrint" />
          <br className="printOnly" />
          <br />
          <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md">
            Restricted States: &nbsp;
          </Text>

          {programData?.document?.restricted_states &&
          programData?.document?.restricted_states.length > 0 ? (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              {programData.document.restricted_states
                .map((state) => {
                  return capitlalizeWordFirstLetter(state.replace(/_/g, ' '));
                })
                .join(', ')}
            </Text>
          ) : (
            <Text color="$core.color.neutral.100" fontWeight="regular" fontSize="md">
              No restricted states
            </Text>
          )}
          <br />

          <br className="noPrint" />
          <br className="printOnly" />
          <React.Fragment>
            <Text color="$core.color.neutral.100" fontWeight="bold" fontSize="md" width="100%">
              Hours
            </Text>
            <br />
            {[
              'sunday',
              'monday',
              'tuesday',
              'wednesday',
              'thursday',
              'friday',
              'saturday',
            ].map((day) => (
              <React.Fragment key={day}>
                <Text
                  color="$core.color.neutral.100"
                  fontWeight="regular"
                  fontSize="md"
                  style={{ lineHeight: 1.5 }}
                >
                  {`${
                    day.charAt(0).toUpperCase() + day.slice(1)
                  }: ${getOpenHoursTextUniteUs(
                    programData?.document?.locations[0]?.hours,
                    day
                  )}`}
                </Text>
                <br />
              </React.Fragment>
            ))}
          </React.Fragment>
        </div>
      </div>
      <footer className="printOnly">
        <hr />
        This resource was shared by United Healthcare Community Resources,
        powered by Unite Us.
      </footer>
    </React.Fragment>
  );
};
